import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {FueltaxService} from '../../service/fueltax/fueltaxService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';


/* global customElements */
class StateTaxRateGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var stateRateGrid = this;
		setTimeout(function(){
			stateRateGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var stateRateGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [								
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'stateProvCode',
					postinit: function(combo) {						
						var lookups = [
							{
								code: 'stateTaxTypeCode',
								description: 'Type'								
							},
							{
								code: 'stateProvCode',
								description: 'State'	
							}
						];
						combo.items = lookups;						
					},
					placeHolder: 'Select'					
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter Value',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				}
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_STATE_TAX_RATES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_STATE_TAX_RATES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['ADMIN_STATE_TAX_RATES:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', 'Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							theme: 'error primary',					
							permissions: ['ADMIN_STATE_TAX_RATES:DELETE'],
							'class': 'spacer-toolbar-item',								
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems);
								}
							}
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},
				{						
					path: 'stateTaxTypeCode',
					header: 'Type',			
					width: '7em'
				},
				{
					tag: 'vaadin-grid-column',
					path: 'startDate',
					header: 'State Date',
					width: '9em'
				},
				{
					tag: 'vaadin-grid-column',
					path: 'endDate',
					header: 'End Date',
					width: '9em'
				},
				{						
					path: 'stateProvCode',
					header: 'State/Prov',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'countryCode',
					header: 'Country',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'taxRate',
					header: 'Tax Rate',
					'text-align': 'end',
					width: '7em'
				},
				{						
					path: 'estimatedFinalRateInd',
					header: 'Estimate/Final',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'tractorGvwrLowWt',
					header: 'GVWR Low',
					'text-align': 'end',
					width: '7em'
				},
				{						
					path: 'tractorGvwrHighWt',
					header: 'GVWR High',
					'text-align': 'end',
					width: '7em'
				},
				{						
					path: 'tractorGvwrEmptyLowWt',
					header: 'Empty Low',
					'text-align': 'end',
					width: '7em'
				},
				{						
					path: 'tractorGvwrEmptyHighWt',
					header: 'Empty High',
					'text-align': 'end',
					width: '7em'
				},
				{						
					path: 'weightUom',
					header: 'Weight UOM',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'axleCount',
					header: 'Axles',
					'text-align': 'center',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 1) {					  					
					ElementUtil.query(toolbar, 'edit').disabled = true;					
					ElementUtil.query(toolbar, 'delete').disabled = false;
				} else if (grid.selectedItems.length === 1) {
					ElementUtil.query(toolbar, 'edit').disabled = false;					
					ElementUtil.query(toolbar, 'delete').disabled = false;
				}else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;
					ElementUtil.query(toolbar, 'delete').disabled = true;
				}
			});
		};	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							filterField: ElementUtil.query(toolbarFilter, 'filterType').value,
							filterValue: ElementUtil.query(toolbarFilter, 'filterValue').value
						};
						
						if (stateRateGrid.admin) {
							var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							if (selectedCompany) {
								grid.currentFilter.companyId = selectedCompany;
							}							
						}
												
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						FueltaxService.getStateTaxService().getStateTaxRates(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'state-tax-rates',
			onDetail: function() {
				actionExport();
			}
		});
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		stateRateGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		attachWorkspaceFilterState(stateRateGrid, toolbarFilter, ['filterType','filterValue'], actionRefresh);
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',
											label: 'Type',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'stateTaxTypeCode',
											required: true,
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('StateTaxTypeCode').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-date-picker',
											itemId: 'startDate',
											name: 'startDate',
											label: 'Start Date',
											required: true
										},
										{
											tag: 'vaadin-date-picker',
											itemId: 'endDate',
											name: 'endDate',
											label: 'End Date',
											required: true
										},
										{										
											tag: 'vaadin-combo-box',
											itemId: 'stateCombo',
											label: 'State / Prov',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'stateProvCode',
											required: true,
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('StateProvCode').then(function(data){													
													combo.items = data;													
												});
											},
											placeHolder: 'Select'					
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Estimate/Final',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'estimatedFinalRateInd',
											required: true,
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('TaxEstimatedFinalCode').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Currency Code',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'currencyCode',											
											value: 'USD',
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('CurrencyCode').then(function(data){
													combo.items = data;
													combo.required = true;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-number-field',
											name: 'taxRate',
											required: true,
											label: 'Tax Rate'
										},
										{
											tag: 'vaadin-number-field',
											name: 'axleCount',
											required: true,
											label: 'Axle Count',
											value: 0
										},
										{
											tag: 'vaadin-number-field',
											name: 'tractorGvwrEmptyLowWt',
											required: true,
											label: 'Empty Low Weight',
											value: 0
										},
										{
											tag: 'vaadin-number-field',
											name: 'tractorGvwrEmptyHighWt',
											required: true,
											label: 'Empty High Weight',
											value: 0
										},
										{
											tag: 'vaadin-number-field',
											name: 'tractorGvwrLowWt',
											required: true,
											label: 'GVWR Low Weight',
											value: 0
										},
										{
											tag: 'vaadin-number-field',
											name: 'tractorGvwrHighWt',
											required: true,
											label: 'GVWR High Weight',
											value: 0
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Weight UOM',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'weightUom',											
											value: 'LB',
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('WeightUOM').then(function(data){
													combo.items = data;
													combo.required = true;
												});
											},
											placeHolder: 'Select'
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																												
															formPanel.submitForm({
																preSubmit: function(data) {		
																	data.startDate = TimeUtil.formatDateOnlyFromDate(data.startDate);
																	data.endDate = TimeUtil.formatDateOnlyFromDate(data.endDate);
																	
																	var countryCode = ElementUtil.query(formPanel, 'stateCombo').selectedItem.country;
																	data.countryCode = countryCode;
																	
																	return data;
																},
																actualCall: function(data) {
																	if (record) {
																		data.highwayTaxRateId = record.highwayTaxRateId;
																	}																	
																	return FueltaxService.getStateTaxService().saveStateTaxRate(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Rate', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						if (record) {	
							formPanel.load(record);		
							
						}
					}
				}
			});			
		};
		
		var actionDelete = function(records) {
	
			var requestModel = {
				ids: []
			};			
			records.forEach(function(item){				
				requestModel.ids.push(item.highwayTaxRateId);
			});
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete the selected rates(s)?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							FueltaxService.getStateTaxService().deleteStateTaxRates(requestModel)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});

					
		};	
		
		var actionUpload = function() {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Import State Tax File',
				icon: 'vaadin:upload',
				width: 450,
				height: 220,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var uploadHandler = function() {
							
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
							
							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A import file is required.');
							} else {
								uploadField.uploadFiles();
							}
							
						};
						
						var uploadFormPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-upload',												
										itemid: 'uploadField',
										'no-auto':  true,
										'max-files': 1,
										required: true,
										target: '/api/resource/state-tax-rates/import',
										headers: ImportUtil.getUploadHeader(),
										listeners: {
											'upload-request': function(event) {
												//var data = uploadFormPanel.getData();												
																							
											},
											'upload-success': function(event) {
												var responseData = JSON.parse(event.detail.xhr.responseText);
												if (responseData.uploadFile) {
													//error 
													window.DL.MessageUtil.showOkMessage(
														responseData.uploadFile + '<br>' +
														responseData.uploadFileType ? responseData.uploadFileType : ''
													);
												} else {
													window.DL.MessageUtil.showToast('Uploaded Successfully', '', {
														theme: 'success'
													});
													
													actionRefresh();
													uploadWin.close();
												}
											}
										}
									},
									{
										tag: 'vaadin-form-layout',										
										children: [											
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:upload', ' Upload')
														],
														listeners: {
															click: function() {
																if (uploadFormPanel.isValid()) {																	
																	uploadHandler();
																}
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {																
																uploadWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
						});
						uploadWin.addToContentElement(uploadFormPanel);
						
					}
				}
				
				
			});					
			
		};
		
		var actionExport = function() {
			FueltaxService.getStateTaxService().exportStateTaxRates(grid.currentFilter);	
		};
		
	}
	
}
customElements.define('dl-statetaxrate-grid', StateTaxRateGrid);
